// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--TNq1Y","labels":"_02712f2b3b--labels--MemYX"};